import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { managerGuard } from './core/auth/manager.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/quality/pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'commandes',
        loadComponent: () =>
          import('./features/quality/pages/orders-list/orders-list.component').then(
            (m) => m.OrdersListComponent,
          ),
      },
      {
        path: 'commandes/:id',
        loadComponent: () =>
          import('./features/quality/pages/order-detail/order-detail.component').then(
            (m) => m.OrderDetailComponent,
          ),
      },
      {
        // Vue Manager : activité nominative par personne. Le guard double la policy
        // backend (l'endpoint renvoie 403 sans le statut manager).
        path: 'manager',
        canActivate: [managerGuard],
        loadComponent: () =>
          import('./features/quality/pages/manager/manager.component').then(
            (m) => m.ManagerComponent,
          ),
      },
      {
        // Détail d'une personne : temps passé par ligne, journée par journée. Même
        // verrou que la vue Manager (l'endpoint renvoie 403 sans le statut manager).
        path: 'manager/:controllerId',
        canActivate: [managerGuard],
        loadComponent: () =>
          import('./features/quality/pages/controller-detail/controller-detail.component').then(
            (m) => m.ControllerDetailComponent,
          ),
      },
      {
        path: 'kpi-qualite',
        loadComponent: () =>
          import('./features/quality/pages/kpi/kpi.component').then((m) => m.KpiComponent),
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
